import { ValueFormatterParams } from "ag-grid-community";
import React, { useCallback, useRef, useState } from "react";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { ColumnDef, GridHandle } from "../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../components/ModalDelete";
import Loading from "../../../../core/common/Loading";
import { formatDateTimeBR } from "../../../../helpers/format";
import { useModal } from "../../../../hooks/ModalContext";
import api from "../../../../services/api";
import Create from "./Create";
import Info from "./Info";
import { IBumerangue } from "./types/types";
import Can from "../../../../components/Can";

const Bumerangue: React.FC = () => {
  const [selectedRow, setSelectedRow] = useState<IBumerangue | undefined>();
  const [isEdit, setIsEdit] = useState(false);
  const [isRemove, setIsRemove] = useState<boolean>(false);
  const [isView, setIsView] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const gridRef = useRef<GridHandle>(null);
  const { openModal, isModalOpen, closeModal } = useModal();
  const selectedTerminalName =
    selectedRow?.terminal?.razao_social ||
    selectedRow?.terminal?.nome_fantasia ||
    "";

  const columns: ColumnDef[] = [
    {
      field: "terminal.razao_social",
      fieldName: "razao_social",
      headerName: "Terminal",
      filter: true,
      width: 320,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) return String(params.value);
        return "-";
      },
    },
    {
      field: "intervalo_dias",
      headerName: "Intervalo em dias",
      filter: true,
      width: 200,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value !== undefined && params.value !== null) {
          return String(params.value);
        }
        return "-";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data modificação",
      filter: true,
      filterParams: { dateBetween: true },
      width: 220,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) return formatDateTimeBR(params.value as string);
        return "-";
      },
    },
  ];

  const onDelete = useCallback(async (entityId?: number) => {
    try {
      if (!entityId) return;
      setLoading(true);
      await api.post("/deletar/comercialBumerangue", {
        id_comercial_bumerangue: entityId,
      });
      setLoading(false);
      setIsRemove(false);
      gridRef.current?.refresh();
    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Loading loading={loading} />

      {isRemove && (
        <ModalDelete
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => onDelete(selectedRow?.id_bumerangue)}
          row={selectedTerminalName}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Bumerangue"
          onClose={() => setIsView(false)}
        />
      )}

      {isModalOpen && (
        <Create
          isEdit={isEdit}
          selectedRow={selectedRow}
          onClear={() => {
            setIsEdit(false);
            closeModal();
          }}
          onConfirm={() => {
            setIsEdit(false);
            closeModal();
            gridRef.current?.refresh();
          }}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Bumerangue</h1>
          </div>
          <div className="mr-14 flex items-center">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => {
                setSelectedRow(undefined);
                setIsEdit(false);
                openModal();
              }}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>

        <div className="flex w-full h-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path="/listar/comercialBumerangue"
            onUpdate={(data: IBumerangue) => {
              setSelectedRow(data);
              setIsEdit(true);
              openModal();
            }}
            onDelete={(data: IBumerangue) => {
              setIsRemove(true);
              setSelectedRow(data);
            }}
            onView={(data: IBumerangue) => {
              setSelectedRow(data);
              setIsView(true);
            }}
            status={[]}
          />
        </div>
      </div>
    </>
  );
};

export default Bumerangue;
